export default "__VITE_ASSET__CR2Mb72F__"